var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ 'normalContainer' :_vm.isMon, 'hugeContainer': !_vm.isMon }},[_c('CNotificationsFromStore'),_c('nav-bar'),_c('v-main',[_c('v-container',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }